import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { ObjectGroupService } from '@app/services/object-group-lines.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { objectGroup } from '@app/models/objectGroup.model';
import { LINE_AUTO_CONDITIONS, LINE_AUTO_SOURCES } from '@app/constants/line-auto-options';
import { LINE_TEXT_ALIGNS } from '@app/constants/line-text-align';
import { TIMELINE_MARKER_OPTIONS } from '@app/constants/timeline-marker-options';
import { UnsavedChangesService } from '@app/services/unsaved-changes.service';
import { TemplateService } from '@app/services/template.service';
@Component({
  selector: 'app-object-group-lines',
  templateUrl: './object-group-lines.component.html',
  styleUrl: './object-group-lines.component.scss'
})

export class ObjectGroupLinesComponent implements OnInit {

  
  ObjGroupLines!: FormGroup;
  ogTypes: any[] = [];
sourceTypes: any[] = [];
shapeTypes: any[] = [];
exitanimTypes: any[] = [];
entryanimTypes: any[] = [];
textalignTypes: any[] = [];
shapeBorderTypes: any[] = [];
shapeShadowTypes: any[] = [];
  readingMaterialTypes: { ValidVal: string }[] = [];
  readonly lineAutoSources = LINE_AUTO_SOURCES;
  readonly lineAutoConditions = LINE_AUTO_CONDITIONS;
  readonly lineTextAligns = LINE_TEXT_ALIGNS;
  readonly timelineMarkerOptions = TIMELINE_MARKER_OPTIONS;

  timelineMarkerSelectOptions(raw: string | null | undefined): { label: string; value: string }[] {
    const v = String(raw ?? '').trim();
    if (!v) return this.timelineMarkerOptions;
    if (this.timelineMarkerOptions.some((o) => o.value === v)) return this.timelineMarkerOptions;
    return [...this.timelineMarkerOptions, { label: `${v} (saved)`, value: v }];
  }

  readingMaterialSelectOptions(raw: string | null | undefined): { ValidVal: string }[] {
    const opts = [{ ValidVal: 'N' }, ...this.readingMaterialTypes];
    const v = String(raw ?? '').trim();
    if (!v) return opts;
    if (opts.some((o) => o.ValidVal.toLowerCase() === v.toLowerCase())) return opts;
    return [...opts, { ValidVal: v }];
  }
  shortcode: string = '';
  private unsavedWired = false;

  groupVisibility = {
    groupLayout: true,
    group1: true,
    group2: true,
    group3: true,
    group4: true,
    group5: true,
    group6: true,
    group7: true,
  };

  constructor(
    private fb: FormBuilder,
    private ObjectGroupService: ObjectGroupService,
    private route: ActivatedRoute,
    private router: Router,
    private unsaved: UnsavedChangesService,
    private templateService: TemplateService
  ) { }
  ngOnInit() {
   // debugger;
    this.initForm();
   this.shortcode =  this.route.snapshot.params['objGroupShortcode'];

    this.ObjectGroupService.getObjectGroupMasterCodes("OGLT").subscribe(types => {
      this.ogTypes = types;
    });
    console.log(this.ogTypes);
    this.ObjectGroupService.getObjectGroupMasterCodes("STYP").subscribe(types => {
      this.sourceTypes = types;
    });
    console.log(this.sourceTypes);
    this.ObjectGroupService.getObjectGroupMasterCodes("SHPTYP").subscribe(types => {
      this.shapeTypes = types;
    });
     console.log(this.shapeTypes);
     this.ObjectGroupService.getObjectGroupMasterCodes("ENTRYANIMTYP").subscribe(types => {
      this.entryanimTypes = types;
    });
     console.log(this.entryanimTypes);
      this.ObjectGroupService.getObjectGroupMasterCodes("EXITANIMTYP").subscribe(types => {
      this.exitanimTypes = types;
    });
     console.log(this.exitanimTypes);

this.ObjectGroupService.getObjectGroupMasterCodes("TEXTALIGNTYP").subscribe(types => {
      this.textalignTypes = types;
    });
     console.log(this.textalignTypes);

     this.ObjectGroupService.getObjectGroupMasterCodes("BORDERTYP").subscribe(types => {
      this.shapeBorderTypes = types;
    });
     console.log(this.shapeBorderTypes);
     this.ObjectGroupService.getObjectGroupMasterCodes("SHADOWTYP").subscribe(types => {
      this.shapeShadowTypes = types;
    });
     console.log(this.shapeShadowTypes);
    this.templateService.getReadingMaterialTypes().subscribe((types) => {
      this.readingMaterialTypes = Array.isArray(types) ? types : [];
    });

    //objGroupShortcode, objGroupName, objGroupRemarks
    this.ObjectGroupService.getobjectGroupWithSC(this.shortcode).subscribe(data => {
    let og = data[0];
      console.log(data);
      this.ObjGroupLines.patchValue({
        objGroupShortcode: og.objGroupShortcode,
        objGroupName: og.objGroupName,
        objGroupRemarks: og.objGroupRemarks,
        objGroupGroupColorFlag: og.objGroupGroupColorFlag || '',
        objGroupXpos: og.objGroupXpos ?? null,
        objGroupYpos: og.objGroupYpos ?? null,
        objGroupWidth: og.objGroupWidth ?? null,
        objGroupHeight: og.objGroupHeight ?? null,
        objGroupOverlapFlag: og.objGroupOverlapFlag || '',
        objGroupFixedSizeFlag: og.objGroupFixedSizeFlag || '',
        objGroupContentAlign: og.objGroupContentAlign || 'LEFT-TOP',
        objGroupMaxRows: og.objGroupMaxRows ?? null,
        objGroupMaxCols: og.objGroupMaxCols ?? null,
        objGroupRowReverseFlag: og.objGroupRowReverseFlag || '',
        objGroupGroupTraverseFlag: og.objGroupGroupTraverseFlag || '',
        objGroupAlternateSkewFlag: og.objGroupAlternateSkewFlag || '',
        objGroupCircleFlag: og.objGroupCircleFlag || '',
        objGroupCircleRadius: og.objGroupCircleRadius ?? null,
        objGroupCircleAngleStart: og.objGroupCircleAngleStart ?? null,
        objGroupCircleAngleEnd: og.objGroupCircleAngleEnd ?? null,
        objGroupCircleFullFlag: og.objGroupCircleFullFlag || '',
        objGroupCircleRotateFlag: og.objGroupCircleRotateFlag || '',
        objGroupCircleRadiusSkew: og.objGroupCircleRadiusSkew ?? null,
      });
    });

    this.ObjectGroupService.getobjectGroupLinesByShortCode(this.shortcode).subscribe(rows => {
     
      this.details.clear();
      rows.forEach((row: any) => {
        console.log(row);
        this.details.push(this.createDetailRow(row));
      });
      console.log(this.details);

      this.ObjGroupLines.markAsPristine();
      this.unsaved.setDirty(false);
      if (!this.unsavedWired) {
        this.unsavedWired = true;
        this.ObjGroupLines.valueChanges.subscribe(() => {
          if (this.ObjGroupLines.dirty) {
            this.unsaved.setDirty(true);
          }
        });
      }
    });
  }

  initForm() {
    this.ObjGroupLines = this.fb.group({
      objGroupShortcode: [{ value: '', disabled: true }],
      objGroupName: [''],
      objGroupRemarks: [''],
      objGroupGroupColorFlag: [''],
      objGroupXpos: [null],
      objGroupYpos: [null],
      objGroupWidth: [null],
      objGroupHeight: [null],
      objGroupOverlapFlag: [''],
      objGroupFixedSizeFlag: [''],
      objGroupContentAlign: ['LEFT-TOP'],
      objGroupMaxRows: [null],
      objGroupMaxCols: [null],
      objGroupRowReverseFlag: [''],
      objGroupGroupTraverseFlag: [''],
      objGroupAlternateSkewFlag: [''],
      objGroupCircleFlag: [''],
      objGroupCircleRadius: [null],
      objGroupCircleAngleStart: [null],
      objGroupCircleAngleEnd: [null],
      objGroupCircleFullFlag: [''],
      objGroupCircleRotateFlag: [''],
      objGroupCircleRadiusSkew: [null],
      details: this.fb.array([]),
    });
  }

  get details(): FormArray {
    return this.ObjGroupLines.get('details') as FormArray;
  }

  createDetailRow(row?: any): FormGroup {
    return this.fb.group({
      lineSrno: [row?.lineSrno || 1],
      OGType: [row?.OGType || ''],
      OGName: [row?.OGName || ''],
      //group1: this.fb.group({
        OGVal: [row?.OGVal || ''],
        OGSourceType: [row?.OGSourceType || ''],
        OGAllowTranslate: [row?.OGAllowTranslate || 'Y'],
        OGTextBreak: [row?.OGTextBreak ?? null],
        ReadingMaterial: [row?.ReadingMaterial || ''],
      //}),
      //group2: this.fb.group({
        OGShapeType: [row?.OGShapeType || ''],
        OGShapeBorder: [row?.OGShapeBorder || ''],
        OGShapeFill: [row?.OGShapeFill || ''],
        OGShapeShadow: [row?.OGShapeShadow || ''],
      //}),
      //group3: this.fb.group({
        OGtextAlign: [row?.OGtextAlign || ''],
        OGTextFont: [row?.OGTextFont || ''],
         OGTextColor: [row?.OGTextColor || ''],
          OGBulletFlag: [row?.OGBulletFlag || ''],
           OGBulletSize: [row?.OGBulletSize || ''],
            OGBulletCharacter: [row?.OGBulletCharacter || ''],
            OGNumTextStyle: [row?.OGNumTextStyle || ''],
      //}),
        OGGroupColorFlag: [row?.OGGroupColorFlag || ''],
        OGXpos: [row?.OGXpos ?? null],
        OGYpos: [row?.OGYpos ?? null],
        OGWidth: [row?.OGWidth ?? null],
        OGHeight: [row?.OGHeight ?? null],
      //group6: this.fb.group({
        OGEntryAnimType: [row?.OGEntryAnimType || ''],
        OGExitAnimType: [row?.OGExitAnimType || ''],
        OGExitAnimTime: [row?.OGExitAnimTime || ''],
        OGPreviousFlag: [row?.OGPreviousFlag || ''],
        OGNextFlag: [row?.OGNextFlag || ''],
        OGReplayFlag: [row?.OGReplayFlag || ''],
        OGAutoSource: [row?.OGAutoSource || ''],
        OGAutoVal: [row?.OGAutoVal ?? ''],
        OGAutoCondition: [row?.OGAutoCondition || ''],
        OGAutoEntryBefore: [row?.OGAutoEntryBefore || ''],
        OGAutoEntryAfter: [row?.OGAutoEntryAfter || ''],
        OGAutoExitBefore: [row?.OGAutoExitBefore || ''],
        OGAutoExitAfter: [row?.OGAutoExitAfter || ''],
        
      //})

      // Add group2, group3 etc. later
    });
  }

  addRow() {
    this.details.push(this.createDetailRow());
  }

  deleteRow(index: number) {
    this.details.removeAt(index);
  }

  moveUp(index: number) {
    if (index > 0) {
      const array = this.details;
      const current = array.at(index);
      array.removeAt(index);
      array.insert(index - 1, current);
    }
  }

  moveDown(index: number) {
    const array = this.details;
    if (index < array.length - 1) {
      const current = array.at(index);
      array.removeAt(index);
      array.insert(index + 1, current);
    }
  }  
  saveOG(): void {
    let newobjectGroup : objectGroup;

    if (this.ObjGroupLines.valid) {
      const payload = this.ObjGroupLines.getRawValue();
      console.log( payload);
       this.ObjectGroupService.saveobjectGroup(payload).subscribe(() => {
      this.ObjGroupLines.markAsPristine();
      this.unsaved.setDirty(false);
      this.router.navigate(['/designer/object-group-list']);
    });
    }
  }
}
